import { render, staticRenderFns } from "./MediaUploader.vue?vue&type=template&id=63673958"
import script from "./MediaUploader.vue?vue&type=script&lang=js"
export * from "./MediaUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports